import React from "react";
import { customerMapsUrl } from "./customerLocationUtils";

const CustomerLocation = ({ customer }) => {
  const address = typeof customer.locationAddress === "string" ? customer.locationAddress.trim() : "";
  const mapsUrl = customerMapsUrl(customer);
  if (!address && !mapsUrl) return null;
  return (
    <div className="node-card__customer-location">
      {address && <p>{address}</p>}
      {mapsUrl && <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
        <i className="fa fa-map-marker mr-1" aria-hidden="true" />Open Google Maps
      </a>}
    </div>
  );
};

export default CustomerLocation;
